import { COMPANY_CONFIG } from "companyConfig";
import { formatPhone } from "utils/formatPhone";

interface MemberServiceProps {
    number?: boolean;
    titleClassName?: string;
}

export const TalkAgent = ({ titleClassName, number = true }: MemberServiceProps) => {
    return (
        <div data-testid="member-service">
            <p className={`text-sm font-bold leading-5 ${titleClassName}`}>Talk to an Agent</p>
            {number && (
                <p className="text-xl font-semibold">
                    <a href={`tel:${COMPANY_CONFIG.numberAgent}`}>{formatPhone(COMPANY_CONFIG.numberAgent)}</a>
                </p>
            )}
        </div>
    );
};
